<ng-template #cdtinfomodal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">
      Carnet de temps
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
    </button>
  </div>
  @if (cdt$ | async; as cdt) {
    <div>
      <div class="modal-body">
        <p>Le carnet de temps est une réserve de temps disponible auprès de notre pôle service afin de traiter rapidement
        vos demandes hors périmètre du contrat de maintenance.</p>
        <p>Attention, le carnet de temps ne peut pas se subsistuer aux prestations.</p>
        <p>Le carnet de temps s'utilise simplement par la déclaration d'une demande avec décompte du temps passé par nos
        intervenants.</p>
        <div>
          <ul>
            <li>
              <span class="fw-bold">Heures totales</span> dans votre carnet de temps : <span
            class="fw-bold">{{ cdt.total | hours }}</span>
          </li>
          <li>
            <span class="fw-bold">Heures consommées</span> dans votre carnet de temps : <span
          class="fw-bold">{{ cdt.consomme | hours }}</span>
        </li>
        <li>
          <span class="fw-bold">Heures restantes</span> dans votre carnet de temps : <span
        class="fw-bold">{{ cdt.reste | hours }}</span>
      </li>
    </ul>
  </div>
  <p>Pour plus d'informations, nous vous invitons à contacter votre référent commercial.</p>
  <div class="d-flex justify-content-center">
    <app-dash-block-commercial class="w-300px"></app-dash-block-commercial>
  </div>
</div>
@if ((cdt.reste > 0 && rolesService.hasProduct())) {
  <div class="modal-footer">
    <app-cancel-button (click)="modal.dismiss()"></app-cancel-button>
    <a class="btn btn-primary" routerLink="/tickets/nouveau" (click)="modal.close()">Déposer un ticket</a>
  </div>
} @else {
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close()">Fermer</button>
  </div>
}
<ng-template #zerofooter>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close()">Fermer</button>
  </div>
</ng-template>
</div>
}

</ng-template>
